var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20360 -2061)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20360 2061)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20354.793 2068.885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2759.637,4148.649q-5.8,0-11.6,0a.909.909,0,0,1-.878-1.394.975.975,0,0,1,.893-.446c.5-.013.993-.011,1.49,0,.24,0,.34-.086.339-.328q-.008-1.591,0-3.183c0-.27-.125-.344-.373-.338-.483.01-.967.014-1.449,0a.962.962,0,0,1-.97-.583.875.875,0,0,1,.666-1.221,3.287,3.287,0,0,1,.6-.056q11.357-.005,22.716,0a2.458,2.458,0,0,1,.517.056.836.836,0,0,1,.718.882.8.8,0,0,1-.726.868,9.088,9.088,0,0,1-1.605.048c-.427-.024-.518.125-.507.524.029.98.024,1.96,0,2.94-.008.339.123.406.423.4.5-.019.994-.022,1.49,0a.878.878,0,0,1,.906.757.864.864,0,0,1-.577,1.024,1.653,1.653,0,0,1-.514.054Q-2753.858,4148.651-2759.637,4148.649Zm-7.894-1.877a1.185,1.185,0,0,0,.164.03c2.171,0,4.344,0,6.515.009.3,0,.353-.14.351-.394-.008-1.005-.018-2.011,0-3.017.008-.37-.137-.445-.473-.443-2.051.012-4.1.005-6.153.006-.13,0-.26.015-.41.022Zm8.848-3.785c0,1.219,0,2.4,0,3.578,0,.281.188.241.359.241,2.094,0,4.187-.007,6.28.008.34,0,.4-.126.4-.425-.014-.993-.021-1.986,0-2.979.008-.357-.1-.456-.455-.453-2.053.015-4.106.006-6.16.007C-2758.379,4142.964-2758.5,4142.977-2758.683,4142.987Z",
    transform: "translate(2772.262 -4128.419)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2701.935,3995.079h-4.914a2.48,2.48,0,0,1-2.635-2.578q-.029-3.041,0-6.082a2.544,2.544,0,0,1,2.733-2.672q4.853,0,9.707,0a2.561,2.561,0,0,1,2.737,2.746q0,3,0,6a2.522,2.522,0,0,1-1.874,2.509,2.565,2.565,0,0,1-.637.071C-2698.524,3995.082-2700.229,3995.08-2701.935,3995.079Zm-2.476-6.378c0-.959-.009-1.844,0-2.729,0-.28-.084-.377-.368-.37-.657.018-1.315,0-1.973.006-.709,0-.88.168-.881.876q0,2.94,0,5.88c0,.717.186.9.912.9q3.323,0,6.646,0c1.047,0,2.094.006,3.141,0,.528,0,.779-.243.781-.76q.011-3.061,0-6.122c0-.546-.224-.764-.756-.769-.712-.007-1.423.008-2.135-.007-.27-.005-.35.1-.346.354.01.725.006,1.45,0,2.174,0,.166-.028.332-.046.54-.713-.355-1.38-.668-2.027-1.017a.79.79,0,0,0-.85-.008C-2702.975,3988.011-2703.666,3988.331-2704.411,3988.7Z",
    transform: "translate(2714.554 -3983.747)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLine);
export default __webpack_public_path__ + "static/media/icon-line.489d3d55.svg";
export { ForwardRef as ReactComponent };